import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {

  @Input() currentPage:number=1;
  @Input() totalPages:number;
  @Output() pageChange=new EventEmitter<number>();
  recordsPerPage:number=10;
  totalRecords:number=100;

 
  onPageChange(newPage:number):void{
    this.pageChange.emit(newPage);
  }
  
}
